
import React, { useEffect, useRef } from 'react';

const Canvas = ({service, image, canvasWidth, canvasHeight, canvasRotationAngle, isFlipVertical, isFlipHorizontal, canvasFormat, createImage, changeImage, editImage} : { service: string, image: string, canvasWidth: number, canvasHeight: number, canvasRotationAngle: number, isFlipVertical: boolean, isFlipHorizontal: boolean, canvasFormat: string, createImage: Function, changeImage: Function, editImage: Function}): JSX.Element => {
	const canvasRef = useRef(null);

	useEffect(() => {
		const canvas: any = canvasRef.current;
		const context = canvas.getContext('2d');
		
		createImage(image).then((imageFile) => { 
			editImage(imageFile, context, service); })
				.then(() => changeImage(canvas.toDataURL(canvasFormat)));
		
	}, [ canvasFormat, canvasWidth, canvasHeight, canvasRotationAngle, isFlipVertical, isFlipHorizontal ]);

	
	return (
		<canvas width={ canvasWidth } height={ canvasHeight } ref={canvasRef}></canvas>
	);
};

export default Canvas;
